
import { ConversionHelper } from '@/helpers/ConversionHelper';
import { DisableFieldAutofill, Wait } from '@/helpers/WebHelper';
import { CustomerService } from '@/services/customer-service';
import { OrdersService } from '@/services/orders-service';
import { Address } from '@/store/models/AddressModel';
import { OrderlineDetails } from '@/store/models/OrderlineModel';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
@Component
export default class AddEditShippingAddressForm extends Vue {
  /* Properties */
  /* Store Actions */
  /* Watchers */
  @Watch('address.Options.RollDirectionId')
  async onRollDirectionChange(val: any, oldVal: any) {
    if (oldVal) {
      await this.getOrderlinesWithSameShippingAddress(this.address.Id);
    }
  }
  @Watch('isValid')
  onAddressChange(val: boolean) {
    this.$emit('isValid', val);
  }
  /* Data */
  address: Address = new Address();
  isFormValid: boolean = false;
  showAddressRollDirectionChangeAlert: boolean = false;
  states: { id: string; name: string }[] = [];
  countries: any[] = [];
  isOrderlineLoading: boolean = false;
  shouldShowAlert: boolean = false;
  isOrderlineChangeAlertClicked: boolean = false;
  orderlinesWithSameAddress: OrderlineDetails[] = [];
  rollDirectionOptions: any = [
    {
      title: '#4 unwind',
      description: 'Left side of label dispenses first. Wound Outside',
      src: require('@/assets/4unwind.svg'),
      value: 4
    },
    {
      title: '#3 unwind',
      description: 'Right side of label dispenses first. Wound Outside',
      src: require('@/assets/3unwind.svg'),
      value: 3
    }
  ];
  /* Async Functions */
  /* Utility Functions */
  getAddress() {
    return this.address;
  }
  setAddress(address: Address) {
    this.address = address;
  }
  onUpdateRollDirectionId(rollDirectionId: number) {
    this.address.Options.RollDirectionId = rollDirectionId;
  }
  /* Loaders */
  async GetStates() {
    const response = await CustomerService.GetStates();
    this.states = Object.keys(response.data).map(key => ({
      id: key,
      name: response.data[key]
    }));
  }
  async GetCountries() {
    const response = await CustomerService.GetCountries();
    this.countries = response.data;
  }
  async getOrderlinesWithSameShippingAddress(addressId: string) {
    if (!addressId) return;
    this.isOrderlineLoading = true;
    const { data: orderlines } = await OrdersService.GetAllOrderlineByShippingIdAndStatus(
      addressId
    );
    if (orderlines && orderlines[0]) {
      this.orderlinesWithSameAddress = orderlines.map(
        (ol: any) => new OrderlineDetails(ol)
      );
      this.showAddressRollDirectionChangeAlert =
        !!this.orderlinesWithSameAddress && this.orderlinesWithSameAddress.length > 0;
    }
    this.isOrderlineLoading = false;
  }
  async updateOrderline(rollDirectionId: number) {
    try {
      if (this.orderlinesWithSameAddress[0]) {
        const orderlines = this.orderlinesWithSameAddress.map(ol => {
          ol.RollDirection.Id = rollDirectionId;
          return ConversionHelper.convertOrderlineToAddModel(ol);
        });
        const model = {
          Orderlines: orderlines
        };
        await OrdersService.SaveOrderlines(model);
        this.orderlinesWithSameAddress = [];
        this.isOrderlineChangeAlertClicked = false;
        this.showAddressRollDirectionChangeAlert = false;
      }
    } catch (err) {
      console.log(err);
    }
  }
  /* Mounted */
  async mounted() {
    await this.GetStates();
    await this.GetCountries();
    if (!this.address.Id) {
      this.address.Country = this.countries[0];
      this.onUpdateRollDirectionId(this.rollDirectionOptions[0].value);
    }
    setTimeout(() => {
      this.shouldShowAlert = this.address.Options.RollDirectionId === 10;
      DisableFieldAutofill('state');
      DisableFieldAutofill('country');
    }, 50);
  }
  /* Computed */
  get isValid() {
    return (
      this.isFormValid &&
      ((this.showAddressRollDirectionChangeAlert && this.isOrderlineChangeAlertClicked) ||
        !this.isOrderlineChangeAlertClicked)
    );
  }
  /* Created */
  /* Emmited Functions */
}
